import { loadRecaptcha } from '../../../js/components/load_recaptcha';
import { isMobile } from '../../../js/modules/utilities';

export const leaseUpForm = () => {
  const leaseUpFormWrapper = document.querySelector('section#lease-up-form');
  const leaseUpForm = leaseUpFormWrapper && leaseUpFormWrapper.querySelector('.lease-up-form');

  if (leaseUpForm) {
    const dropdownList = leaseUpForm.querySelectorAll('.dropdown');
    const submitBtn = leaseUpForm.querySelector('#submit_btn');
    const body = document.body;

    const fields = {
      FirstName: leaseUpForm.querySelector('input[name="FirsName"]'),
      LastName: leaseUpForm.querySelector('input[name="LastName"]'),
      Email: leaseUpForm.querySelector('input[name="Email"]'),
      Phone: leaseUpForm.querySelector('input[name="Phone"]'),
      Floorplan: leaseUpForm.querySelector('input[name="Floorplan"]'),
      MoveInDate: leaseUpForm.querySelector('input[name="MoveInDate"]'),
      SmsInput: leaseUpForm.querySelector('input[name="sms"]'),
      PropertyID: leaseUpForm.querySelector('input[name="PropertyID"]'),
    }

    const successModalWrapper = leaseUpFormWrapper.querySelector('#lease-up-form-success-modal');
    const modalCloseBtn = successModalWrapper && successModalWrapper.querySelector('#lease-up-form-success-modal__close-btn');

    const closeBtnHandler = (e) => {
      e.stopPropagation();
      successModalWrapper.classList.remove('show');
      leaseUpForm.classList.remove('submitting');
      document.body.classList.remove('body--scroll-locked');
      leaseUpFormWrapper.classList.remove('show');
    }

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', closeBtnHandler);
    }

    const toggleDropdown = (event, dropdown) => {
      event.stopPropagation();
      event.preventDefault();
      if (dropdown.classList.contains('opened')) {
        dropdown.classList.remove('opened');
      } else {
        closeDropdownFromOutside();
        dropdown.classList.add('opened');
        dropdown.classList.remove('error');
      }
    };

    const selectOption = (event, input) => {
      input.value = event.currentTarget.textContent;
      input.dataset.key = event.currentTarget.dataset.key;
      closeDropdownFromOutside();
    };

    const closeDropdownFromOutside = () => {
      dropdownList.forEach((dropdown) => dropdown.classList.remove('opened'));
    };

    body.addEventListener('click', closeDropdownFromOutside);

    dropdownList.forEach((dropdown) => {
      const label = dropdown.querySelector('label#dropdown');
      const input = dropdown.querySelector('input#dropdown');
      const listOfOptions = dropdown.querySelectorAll('.option');
      const options = dropdown.querySelector('ul.options');

      options.addEventListener('click', (e) => e.stopPropagation());
      listOfOptions.forEach((option) => {
        option.addEventListener('click', (e) => selectOption(e, input));
      });
      label.addEventListener('click', (e) => toggleDropdown(e, dropdown));
    });
    let isGcaptchaSuccess = false;

    const gcaptcha = leaseUpForm.querySelector('.g-recaptcha');
    if (gcaptcha) {
      const gcaptchaId = 'lease-up';
      loadRecaptcha(gcaptchaId);
      document.addEventListener('g-captcha', (e) => {
        if (e.detail.id === gcaptchaId) {
          isGcaptchaSuccess = true;
          if (submitBtn) {
            submitBtn.removeAttribute('disabled');
          }
        }
      });
      document.addEventListener('g-captcha-expired', (e) => {
        if (e.detail.id === gcaptchaId) {
          isGcaptchaSuccess = false;
          if (submitBtn) {
            submitBtn.setAttribute('disabled', 'disabled');
          }
        }
      });
    }

    const setInputErrorValue = (input, value) => {
      const inputWrapper = input.closest('div');
      if (inputWrapper) {
        inputWrapper.classList.add('error');
        const errorWrapper = inputWrapper.querySelector('div');
        const errorValue = errorWrapper && errorWrapper.querySelector('span');
        if (errorValue) {
          errorValue.innerHTML = value;
        }
      }
    }

    const validateForm = () => {
      let isValid = true;
      if (gcaptcha) {
        isValid = isGcaptchaSuccess;
      }
      const body = {
        firstName: fields.FirstName.value,
        lastName: fields.LastName.value,
        email: fields.Email.value,
        phone: fields.Phone.value,
        floorplan: fields.Floorplan.dataset.key,
        moveInDate: fields.MoveInDate.dataset.key,
        sms: fields.SmsInput.checked,
        PropertyID: fields.PropertyID.value,
      }
      return {
        isValid,
        body,
      }
    }

    const setModalValues = (body = {}, successMessage = {}) => {
      const dynamicMessage = successModalWrapper.querySelector('#dynamic-message');
      const line1 = dynamicMessage.querySelector('.line-1');
      if (line1) {
        line1.innerHTML = successMessage.Line1.replace('{FirstName}', body.firstName);
      }
      const line2 = dynamicMessage.querySelector('.line-2');
      if (line2) {
        line2.innerHTML = successMessage.Line2;
      }
      const line3 = dynamicMessage.querySelector('.line-3');
      if (line3) {
        line3.innerHTML = successMessage.Line3;
      }
      const line4 = dynamicMessage.querySelector('.line-4');
      if (line4) {
        line4.innerHTML = successMessage.Line4.replace('{Email}', body.email);
      }
    }

    const submitFormRequest = (body) => {
      return fetch('/maa-api/forms/v1/lease-up/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(body),
      })
        .then(response => response.json())
        .then(response => {
          return response;
        })
    }

    const submitForm = (body) => {
      leaseUpForm.classList.add('submitting');
      submitFormRequest(body)
      // Promise.resolve()
        .then((response) => {
          // response = {
          //   "IsSuccess": true,
          //   "StatusCode": 400,
          //   "ValidationErrors": [
          //     {
          //       "Errors": [
          //         "This field is required"
          //       ],
          //       "FieldName": "formData.FirstName"
          //     },
          //     {
          //       "Errors": [
          //         "This field is required"
          //       ],
          //       "FieldName": "formData.LastName"
          //     },
          //     {
          //       "Errors": [
          //         "Invalid Value"
          //       ],
          //       "FieldName": "formData.Email"
          //     },
          //     {
          //       "Errors": [
          //         "Invalid Value"
          //       ],
          //       "FieldName": "formData.Phone"
          //     },
          //     {
          //       "Errors": [
          //         "This field is required"
          //       ],
          //       "FieldName": "formData.Floorplan"
          //     },
          //     {
          //       "Errors": [
          //         "This field is required"
          //       ],
          //       "FieldName": "formData.MoveInDate"
          //     }
          //   ],
          //   "SuccessMessage": {
          //     "Line1": 'Welcome, {FirstName}!',
          //     "Line2": 'You have successfully joined our VIP List',
          //     "Line3": 'An email confirmation will be sent to ',
          //     "Line4": '{Email}',
          //   },
          //   "ErrorMessage": "Bad Request"
          // }
          if (response.IsSuccess === true) {
            setModalValues(body, response.SuccessMessage);
            submitBtn.innerHTML = submitBtn.dataset.successText;
            if (isMobile) {
              document.body.classList.add('body--scroll-locked');
            }
            successModalWrapper.classList.add('show');
          } else if (response.ValidationErrors && response.ValidationErrors.length) {
            leaseUpForm.classList.remove('submitting');
            response.ValidationErrors.forEach((field) => {
              const fieldNameArray = field.FieldName.split('.');
              if (fieldNameArray.length === 2 && field.Errors.length > 0) {
                const fieldName = fieldNameArray[1];
                const [error] = field.Errors;
                setInputErrorValue(fields[fieldName], error);
              }
            })
          } else {
            leaseUpForm.classList.remove('submitting');
          }
        })
        .catch((error) => {
          console.error(error);
          leaseUpForm.classList.remove('submitting');
        });
    }

    const submitBtnHandler = () => {
      const { isValid, body } = validateForm();
      if (isValid) {
        submitForm(body);
      }
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', submitBtnHandler);
    }

    const openFormHandler = () => {
      fields.FirstName.value = '';
      fields.LastName.value = '';
      fields.Email.value = '';
      fields.Phone.value = '';
      fields.SmsInput.checked = false;
      fields.Floorplan.dataset.key = '';
      fields.Floorplan.value = '';
      fields.MoveInDate.dataset.key = '';
      fields.MoveInDate.value = '';
      isGcaptchaSuccess = false;
      submitBtn.innerHTML = submitBtn.dataset.initialText;
      if (gcaptcha) {
        window.grecaptcha.reset();
      }
    }

    document.addEventListener('leasUpFormOpened', openFormHandler);

    const removeInputError = (input) => {
      const inputWrapper = input.closest('div');
      if (inputWrapper) {
        inputWrapper.classList.remove('error');
      }
    }

    fields.FirstName.addEventListener('keypress', (e) => {
      removeInputError(fields.FirstName);
    })
    fields.LastName.addEventListener('keypress', () => {
      removeInputError(fields.LastName);
    })
    fields.Email.addEventListener('keypress', () => {
      removeInputError(fields.Email);
    })
    fields.Phone.addEventListener('keypress', (e) => {
      const regex = /[\d()+-]+/;
      if (!e.key.match(regex)) {
        e.preventDefault();
      } else {
        removeInputError(fields.Phone);
      }
    })

  }
}



// WEBPACK FOOTER //
// ./src/templates/components/lease-up-form/lease-up-form.js